//TODO почему это здесь
export const NO_INFO_MESSAGE = 'нет информации о точке';
